<template>
  <div class="container">
    <!-- 面包屑导航 -->
    <div class="breadcrumb">
      <el-breadcrumb separator="">
        <el-breadcrumb-item>
          <div class="div1">基本配置</div>
        </el-breadcrumb-item>
        <el-breadcrumb-item>
          <div class="div2">员工列表</div>
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <!-- 面包屑导航 -->
    <div class="Box">
      <div class="table_tab">
        <div class="inquiry">
          <div class="headerbox">
            <div class="header">
              <div class="title_left"></div>
              员工
            </div>
            <div class="headerbox_right">
              <el-button size="mini" type="primary" @click="refresh()">刷新</el-button>
              <el-button size="mini" @click="back()">返回</el-button>
            </div>
          </div>
          <div class="headerTitle">数据筛选</div>
          <el-form :inline="true" ref="queryForm" :model="queryForm" label-width="" size="mini">
            <el-form-item label="昵称">
              <el-input placeholder="请输入" clearable v-model="queryForm.reallyName"></el-input>
            </el-form-item>
            <el-form-item label="工作手机号">
              <el-input placeholder="请输入" clearable v-model="queryForm.workPhone"></el-input>
            </el-form-item>
            <el-form-item label="手机号">
              <el-input placeholder="请输入" clearable v-model="queryForm.phoneNumber"></el-input>
            </el-form-item>
            <el-form-item label="旧五域账号">
              <el-input placeholder="请输入" clearable v-model="queryForm.oldAccount"></el-input>
            </el-form-item>
            <el-form-item label="工号">
              <el-input placeholder="请输入" clearable v-model="queryForm.serial"></el-input>
            </el-form-item>
            <el-form-item label="部门">
              <el-cascader @change="handleSelectOrgId" v-model="queryForm.orgId" :options="options"
                :show-all-levels="false" :props="{
                  checkStrictly: true,
                  label: 'orgName',
                  value: 'orgCode',
                  children: 'children',
                }" clearable filterable></el-cascader>
            </el-form-item>
            <el-form-item label="职位">
              <el-select @change="handleSelectPositionId" v-model="queryForm.positionId" placeholder="请选择" clearable
                filterable>
                <el-option v-for="items in positionList" :key="items.id" :label="items.name"
                  :value="items.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="角色">
              <el-select @change="handleSelectRoleId" v-model="queryForm.roleId" placeholder="请选择" clearable filterable>
                <el-option v-for="items in roleDataList" :key="items.id" :label="items.name"
                  :value="items.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="在职">
              <el-select @change="handleSelectStatus" v-model="queryForm.status" placeholder="请选择" clearable>
                <el-option v-for="items in dictionaries.employee_status" :key="items.dictId" :label="items.dictName"
                  :value="items.dictId"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button @click="searchEvent('search')" plain v-on:keyup.enter="searchEvent('search')" type="primary">搜索
              </el-button>
              <el-button plain @click="reset()" type="primary">重置</el-button>
              <el-button v-if="parArray.indexOf('ygAdd') != -1" @click="toInfo('add')" type="primary">新增</el-button>
              <el-button v-if="parArray.indexOf('refreshUser') != -1" @click="toRefreshUser()" type="primary">刷新用户</el-button>
            </el-form-item>
          </el-form>
        </div>
        <div class="inquiryTab">
          <div class="tabTitle">员工列表</div>
          <div class="table">
            <el-table border :data="tableData.list" :header-cell-style="{ background: '#f8f8f8' }" style="width: 100%"
              align="center">
              <el-table-column label="昵称" min-width="120" prop="reallyName">
                <template slot-scope="props">
                  <p class="btnp" @click="toInfo('view', props.row)">
                    {{ props.row.reallyName }}
                  </p>
                </template>
              </el-table-column>
              <el-table-column label="工作手机号" prop="workPhone" min-width="120">
              </el-table-column>
              <el-table-column label="手机号" prop="phoneNumber" min-width="130">
                <template slot-scope="props">
                  <div>{{ props.row.phoneNumber }}</div>
                  <div>手机号1: {{ props.row.extraPhoneFirst || '--' }}</div>
                  <div>手机号2: {{ props.row.extraPhoneSecond || '--' }}</div>
                </template>
              </el-table-column>
              <el-table-column label="工号" min-width="100">
                <template slot-scope="props">
                  <span>{{ props.row.serial }}</span>
                </template>
              </el-table-column>
              <el-table-column label="性别" prop="sexLabel" min-width="50"></el-table-column>
              <el-table-column label="部门" prop="orgName" min-width="80"></el-table-column>
              <el-table-column label="职位" prop="positionName" width="100"></el-table-column>
              <el-table-column width="150" label="角色">
                <template slot-scope="props">
                  <p v-for="item in props.row.roleName" :key="item.index">
                    {{ item }}
                  </p>
                </template>
              </el-table-column>
              <el-table-column width="150" label="旧五域账号" prop="oldAccount"></el-table-column>
              <el-table-column width="200" label="最后更新时间" prop="updatedTime"></el-table-column>
              <el-table-column width="90" label="在职状态" prop="status">
                <template slot-scope="props">
                  <p :class="props.row.status == 'A' || props.row.status == 'T' || props.row.status == 'W'
                    ? 'green'
                    : '' || props.row.status == 'S'
                      ? 'red'
                      : '' || props.row.status == 'X'
                        ? 'gray'
                        : ''
                    ">
                    {{
                      props.row.statusLabel
                    }}
                  </p>
                </template>
              </el-table-column>

              <el-table-column label="操作" width="150" fixed="right">
                <template slot-scope="props">
                  <p class="btnp" v-if="parArray.indexOf('ygdetail') != -1" @click="toInfo('view', props.row)">查看</p>
                  <p class="btnp" v-if="parArray.indexOf('userUpdate') != -1" @click="toInfo('edit', props.row)">编辑</p>
                  <p v-if="parArray.indexOf('setPass') != -1" class="btnp" @click="setPassword(props.row)">
                    设置密码
                  </p>
                  <p v-if="parArray.indexOf('ygPhone') != -1" class="btnp" @click="setPhone(props.row)">
                    设置工作手机号
                  </p>
                  <p v-if="parArray.indexOf('staffLogin') != -1" class="btnp" @click="staffLogin(props.row)">
                    登录后台</p>
                  <p class="btnp" v-if="parArray.indexOf('userDelete') != -1" @click="removeEmployee(props.row)">删除</p>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </div>
    <!-- 分页start -->
    <div class="page" v-if="tableData.totalNum > 0">
      <div class="block">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNo"
          :page-sizes="[10, 20, 50, 100, 200]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="tableData.totalNum" prev-text="上一页" next-text="下一页">
        </el-pagination>
      </div>
    </div>
    <!-- 分页end -->

    <!-- 查看信息对话框 -->
    <el-dialog :title="addDialog.title" :close-on-click-modal="false" append-to-body :visible.sync="toInfoDialogVisible"
      width="30%" :before-close="handleCloseToInfo">
      <el-form ref="form" :rules="rulesAddOrUpdate" size="mini" :model="form" label-width="100px">
        <el-form-item label="昵称" prop="reallyName">
          <el-input :disabled="userFixable" v-model="form.reallyName"></el-input>
        </el-form-item>
        <el-form-item label="工作手机号" prop="workPhone">
          <el-input :disabled="userFixable" v-model="form.workPhone" maxLength="11"></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="phoneNumber">
          <el-input :disabled="userFixable" v-model="form.phoneNumber" maxLength="11"></el-input>
        </el-form-item>
        <el-form-item label="手机号1" prop="extraPhoneFirst">
          <el-input :disabled="userFixable" v-model="form.extraPhoneFirst" maxLength="11"></el-input>
        </el-form-item>
        <el-form-item label="手机号2" prop="extraPhoneSecond">
          <el-input :disabled="userFixable" v-model="form.extraPhoneSecond" maxLength="11"></el-input>
        </el-form-item>
        <el-form-item label="设置密码" prop="password" v-if="addDialog.type === 'add'">
          <el-input type="password" placeholder="请输入密码" v-model="form.password"></el-input>
        </el-form-item>
        <el-form-item label="工号" prop="serial">
          <el-input :disabled="userFixable" v-model="form.serial"></el-input>
        </el-form-item>
        <el-form-item label="性别" prop="sex">
          <el-select v-model="form.sex" :disabled="userFixable" placeholder="请选择">
            <el-option v-for="item in dictionaries.employee_sex" :key="item.dictId" :label="item.dictName"
              :value="item.dictId">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="部门" prop="orgCode">
          <el-cascader @change="handleFormOrgId" :disabled="userFixable" v-model="form.orgCodes" :options="options"
            :show-all-levels="false" :props="{
              checkStrictly: true,
              label: 'orgName',
              value: 'orgCode',
              children: 'children',
            }" clearable filterable></el-cascader>
        </el-form-item>
        <el-form-item label="职位" prop="positionCode">
          <el-select v-model="form.positionCode" :disabled="userFixable" placeholder="请选择" clearable filterable>
            <el-option v-for="item in positionList" :key="item.positionCode" :label="item.name"
              :value="item.positionCode">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="系统角色" prop="autoRoleIds">
          <el-select v-model="form.autoRoleIds" disabled placeholder="请选择" clearable multiple filterable>
            <el-option v-for="item in roleDataList" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="角色" prop="roleIds">
          <el-select v-model="form.roleIds" :disabled="userFixable" placeholder="请选择" clearable multiple filterable>
            <el-option v-for="item in roleDataList" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="旧五域账号" prop="sex" v-if="addDialog.type !== 'add'">
          <el-input :disabled="true" v-model="form.oldAccount"></el-input>
        </el-form-item>
        <el-form-item label="在职状态" prop="status">
          <el-select v-model="form.status" placeholder="请选择" clearable :disabled="userFixable">
            <el-option v-for="items in dictionaries.employee_status" :key="items.dictId" :label="items.dictName"
              :value="items.dictId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否员工" prop="employeeFlag">
          <el-select v-model="form.employeeFlag" placeholder="请选择" clearable :disabled="addDialog.type !== 'add'">
            <el-option v-for="items in employeeFlags" :key="items.dictId" :label="items.dictName"
              :value="items.dictId"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" v-if="addDialog.type !== 'view'">
        <el-button @click="toInfoDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleSaveUpdate">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 查看信息对话框结束 -->
    <!-- 设计密码对话框 -->
    <el-dialog title="设置密码" :close-on-click-modal="false" append-to-body :visible.sync="setPasswordDialogVisible"
      width="30%" :before-close="handleCloseSetPassword">
      <el-form ref="formPass" :rules="rulesSetPass" :model="formPass" label-width="100px">
        <el-form-item label="设置密码" prop="setPasswordDate">
          <el-input type="password" placeholder="请输入密码" v-model="formPass.setPasswordDate"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="setPasswordDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="setPasswordConfirm('formPass')">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 设计密码对话框 -->
    <el-dialog title="刷新用户" :close-on-click-modal="false" append-to-body :visible.sync="refreshUserDialogVisible"
               width="30%" :before-close="handleCloseRefreshUser">
      <el-form ref="formRU" :rules="rulesRefreshRU" :model="formRU" label-width="100px">
        <el-form-item label="刷新用户" prop="phoneNumber">
          <el-input type="text" placeholder="请输入手机号" v-model="formRU.phoneNumber"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="refreshUserDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="refreshUserConfirm('formRU')">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 设计密码对话框结束 -->
    <!-- 设置工作手机号对话框 -->
    <el-dialog title="设置工作手机号" :close-on-click-modal="false" append-to-body :visible.sync="setPhoneDialogVisible"
      width="30%" :before-close="handleCloseSetPhone">
      <el-form ref="ruleForm" :rules="rulesSetPhone" :model="ruleForm" label-width="130px">
        <el-form-item label="设置工作手机号" prop="setPhoneDate">
          <el-input placeholder="设置工作手机号" autocomplete="off" v-model="ruleForm.setPhoneDate" maxLength="11"></el-input>
        </el-form-item>
        <el-form-item label="手机号1" prop="extraPhoneFirst">
          <el-input :disabled="userFixable" v-model="ruleForm.extraPhoneFirst" maxLength="11"></el-input>
        </el-form-item>
        <el-form-item label="手机号2" prop="extraPhoneSecond">
          <el-input :disabled="userFixable" v-model="ruleForm.extraPhoneSecond" maxLength="11"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="setPhoneDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="setPhoneConfirm('ruleForm')">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 设置工作手机号对话框结束-->
  </div>
</template>

<script>
import VDistpicker from "v-distpicker";

export default {
  watch: {
    setPhoneDialogVisible(val) {
      console.log(val)
      if (val == false) {
        this.ruleForm.setPhoneDate = ""
      }
    },
    setPasswordDialogVisible(val) {
      console.log(val)
      if (val == false) {
        this.formPass.setPasswordDate = ""
      }
    },
  },
  components: {
    VDistpicker,
  },
  data() {

    // 自定义输入框正则校验
    var checkPhone = (rule, value, callback) => {
      console.log(value);
      const phoneReg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
      if (!Number.isInteger(+value)) {
        callback(new Error("请输入数字值"));
      } else {
        if (phoneReg.test(value)) {
          callback();
        } else {
          callback(new Error("电话号码格式不正确"));
        }
      }
    };
    // var validatePass = (rule, value, callback) => {
    //   const reg = /^[a-zA-Z]\w{5,32}$/;
    //   if (value === "") {
    //     callback(new Error("请输入密码"));
    //   } else {
    //     if (reg.test(value)) {
    //       callback();
    //     } else {
    //       callback(new Error("密码以字母开头 长度在6~32之间 只能包含字母、数字和下划线"));
    //     }
    //   }
    // };
    // 自定义输入框正则校验结束

    return {
      employeeFlags: [
        {
          dictId: 1,
          dictName: '是'
        },
        {
          dictId: 0,
          dictName: '否'
        }
      ],
      toInfoDialogVisible: false,//查看 详情对话框
      setPasswordDialogVisible: false,//设置密码对话框
      setPhoneDialogVisible: false,//设置工作手机号
      date: "",
      // filterText: "",
      position: [
        {
          label: "正常",
          value: 'A'
        },
        {
          label: "停用",
          value: 'S'
        },
        {
          label: "删除",
          value: 'X'
        }
      ],


      queryForm: {
        orgId: "",
        reallyName: "",
        workPhone: '',
        phoneNumber: "",
        oldAccount: "",
        serial: "",
        positionId: "",
        roleId: "",
        status: "",

      },
      userFixable: false,
      form: {
        autoRoleIds: [],
        reallyName: "",
        workPhone: "",
        phoneNumber: "",
        extraPhoneFirst: '',
        extraPhoneSecond: '',
        serial: "",
        sexLabel: "",
        orgCode: "",
        orgName: "",
        positionName: "",
        roleIds: [],
        oldAccount: "",
        statusLabel: "",
        employeeFlag: null

      },
      pageNo: 1,
      pageSize: 10,
      tableData: [],
      options: [],
      statusList: [],
      tree: [],
      // defaultProps: {
      //     children: "children",
      //     label: "orgName",
      // },
      orgCode: "",
      roleVisible: false, //分配角色弹框
      authority: "",
      roleCont: [],
      limits: "",
      parArray: [],
      btnloading: false,
      employeeId: "",
      height: "500px",
      ruleForm: {
        setPhoneDate: "",//设置工作手机号
        extraPhoneFirst: '',
        extraPhoneSecond: '',
      },
      formPass: {
        setPasswordDate: "",//设置密码

      },
      rulesSetPhone: {
        setPhoneDate: [
          { validator: checkPhone, trigger: "blur" }
        ],
      },
      rulesSetPass: {
        setPasswordDate: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 6, max: 32, message: '长度在 6 到 32 个字符', trigger: 'blur' }
        ],
      },
      rulesAddOrUpdate: {
        reallyName: [
          { required: true, message: '请输入昵称', trigger: 'blur' }
        ],
        phoneNumber: [
          { required: true, message: '请输入手机号', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ],
        status: [
          { required: true, message: '请选择在职状态', trigger: 'blur' }
        ],
        positionCode: [
          { required: true, message: '请选择职位', trigger: 'blur' }
        ],
        orgCode: [
          { required: true, message: '请选择部门', trigger: 'blur' },
          { min: 1, max: 5, message: '请选择部门', trigger: 'blur' }
        ],
        employeeFlag: [
          { required: true, message: '请选择是否员工', trigger: 'change' }
        ]
      },
      addDialog: {
        title: "查看用户信息",
        type: "view"
      },
      passwordId: "",//设置密码需要的id
      PhoneID: "",//设置手机号需要的id
      positionList: "",//职位列表数据
      roleDataList: "",//角色下拉数据列表
      statusColor: "",
      dictionaries: { // 字典数据
        employee_sex: [], // 员工性别字典
        employee_status: [], // 员工在职状态字典
      },
      refreshUserDialogVisible: false,//刷新用户信息对话框
      formRU: {
        phoneNumber: "",//刷新用户信息
      },
      rulesRefreshRU: {
        phoneNumber: [
          { required: true, message: '请输入手机号', trigger: 'blur' }
        ],
      }
    };
  },
  mounted() {
    let self = this;
    let ph = document.documentElement.clientHeight;
    self.height = ph - 350 + "px";
    window.onresize = function () {
      let ph = document.documentElement.clientHeight;
      self.height = ph - 350 + "px";
    };
  },
  created() {
    this.getStaffList();
    this.getPositionList()
    this.getRoleList()

    this.department();
    this.statusData();

    // 权限设定判断
    this.limits = JSON.parse(sessionStorage.getItem('limit'))
    const params = this.limits.buttonTreeDto.filter(
      (item) => item.menuCode === 'staffListCode'
    )
    params[0].buttonList.forEach((item) => {
      this.parArray.push(item.code)
    })
    console.log(this.parArray)
    // 权限设定判断
    document.onkeydown = (e) => {
      let key = window.event.keyCode;
      if (key == 13) {
        this.searchEvent();
      }
    };

    // 获取字典值
    for (const type in this.dictionaries) {
      this.getDictionaries(type)
    }
  },
  beforeRouteLeave(to, form, next) {
    document.onkeydown = null;
    next();
  },

  methods: {
    // 获取字典数据
    getDictionaries(type) {
      if (type && this.dictionaries[type].length > 0) {
        return
      }
      const params = { groupId: type }
      this.$api.dictionaries(params).then((res) => {
        this.dictionaries[type] = res.data
      }).catch((err) => {
        console.log(err)
      })
    },
    handleSelectStatus(e) {
      console.log(e)
      this.queryForm.status = e;
      this.getStaffList('search')

    },
    handleSelectPositionId(e) {
      console.log(e)
      this.queryForm.positionId = e;
      this.getStaffList('search')
    },
    handleSelectRoleId(e) {
      console.log(e)
      this.queryForm.roleId = e;
      this.getStaffList('search')
    },
    handleSelectOrgId(e) {
      console.log(e)
      this.queryForm.orgId = e
      this.getStaffList('search')
    },
    // 查询职位下拉列表数据
    getPositionList() {
      const data = {}
      this.$api.staffListSelect(data).then((res) => {
        if (res.code == 0) {
          this.positionList = res.data
        }
        console.log(res)
      }).catch((err) => {
        console.log(err)
      })
    },
    getStaffList(type) {
      const data = {
        orgId: this.queryForm.orgId[this.queryForm.orgId.length - 1],
        reallyName: this.queryForm.reallyName,
        workPhone: this.queryForm.workPhone,
        phoneNumber: this.queryForm.phoneNumber,
        oldAccount: this.queryForm.oldAccount,
        serial: this.queryForm.serial,
        positionId: this.queryForm.positionId,
        roleId: this.queryForm.roleId,
        status: this.queryForm.status,
        pageNo: this.pageNo,
        pageSize: this.pageSize,
      }
      if (type === 'search') {
        this.pageNo = 1
        data.pageNo = 1
      }
      this.$api.staffPageList(data).then((res) => {
        if (res.code == 0) {
          this.tableData = res.data
        }
        console.log(res)
      }).catch((err) => {
        console.log(err)
      })
    },
    // 刷新
    refresh() {
      this.queryForm = {}
      this.queryForm.orgId = ""
      this.getStaffList()
      this.getPositionList()
      this.$forceUpdate();
    },
    // 返回
    back() {
      this.$router.go(-1)
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.orgName.indexOf(value) !== -1;
    },
    handleFormOrgId(e) {
      console.log(e)
      if (!e) {
        this.form.orgCode = ""
        return
      }
      this.form.orgCode = e[e.length - 1]
    },
    // 查看基本信息
    toInfo(type, row) {
      this.userFixable = false;
      this.addDialog.type = type;
      if (type === 'add') {
        this.form = {
          status: 'A'
        }
        this.addDialog.title = '新增用户';
        this.toInfoDialogVisible = true;
        return
      }
      if (type === 'edit') {
        this.addDialog.title = '编辑用户';
      } else {
        this.userFixable = true;
        this.addDialog.title = '查看用户';
      }
      this.toInfoDialogVisible = true;
      this.$api.staffDetail({
        id: row.id,
        winType: 1
      }).then((res) => {
        if (res.code == 0) {
          this.form = res.data
          this.form.orgCodes = res.data.orgCode
        }
      }).catch((err) => {
        console.log(err)
      })
      this.statusColor = row.status
    },
    isValidLength(str) {
      const reg = /^1[3456789]\d{9}$/;
      return reg.test(str)
    },
    handleSaveUpdate() {
      console.log(this.isValidLength(this.form.workPhone))
      if (!this.isValidLength(this.form.workPhone) && this.form.workPhone) {
        this.$message({
          type: 'error',
          message: '请输入正确的工作手机号'
        })
        return
      }

      if (!this.isValidLength(this.form.phoneNumber)) {
        this.$message({
          type: 'error',
          message: '请输入正确的手机号'
        })
        return
      }
      if (!this.isValidLength(this.form.extraPhoneFirst) && this.form.extraPhoneFirst) {
        this.$message({
          type: 'error',
          message: '请输入正确的手机号1'
        })
        return
      }
      if (!this.isValidLength(this.form.extraPhoneSecond) && this.form.extraPhoneSecond) {
        this.$message({
          type: 'error',
          message: '请输入正确的手机号2'
        })
        return
      }
      if (this.addDialog.type === 'edit') {
        this.$api.updateEmployee(this.form).then((res) => {
          console.log(res)
          if (res.code == 0) {
            this.$message({
              type: 'success',
              message: '修改成功!'
            });
            this.toInfoDialogVisible = false;
            this.getStaffList()
          }
        });
      } else {
        this.$api.addEmployee(this.form).then((res) => {
          console.log(res)
          if (res.code == 0) {
            this.$message({
              type: 'success',
              message: '新增成功!'
            });
            this.toInfoDialogVisible = false;
            this.getStaffList()
          }
        });
      }
    },
    removeEmployee(row) {
      this.$confirm('此操作将删除用户，被删除的用户将不能登录，是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const data = { id: row.id }
        this.$api.removeEmployee(data).then((res) => {
          this.getStaffList()
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
        }).catch((err) => {
          console.log(err)
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    // 设置密码
    setPassword(row) {
      this.passwordId = row.id
      this.setPasswordDialogVisible = true;
    },
    // 设置密码确定按钮
    setPasswordConfirm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const data = {
            userId: this.passwordId,
            password: this.formPass.setPasswordDate
          }
          this.$api.staffUpdatePassword(data).then(res => {
            console.log(res)
            if (res.code == 0) {
              this.$message.success("设置成功！")
              this.setPasswordDialogVisible = false
              this.getStaffList()

            } else {
              this.$message.error("设置失败！")
            }
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    // 设置工作手机号确定按钮
    setPhoneConfirm(formName) {
      if (!this.isValidLength(this.ruleForm.setPhoneDate)) {
        this.$message({
          type: 'error',
          message: '请输入正确的工作手机号'
        })
        return
      }
      if (!this.isValidLength(this.ruleForm.extraPhoneFirst) && this.ruleForm.extraPhoneFirst) {
        this.$message({
          type: 'error',
          message: '请输入正确的手机号1'
        })
        return
      }
      if (!this.isValidLength(this.ruleForm.extraPhoneSecond) && this.ruleForm.extraPhoneSecond) {
        this.$message({
          type: 'error',
          message: '请输入正确的手机号2'
        })
        return
      }
      console.log(formName)
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const data = {
            userId: this.PhoneID,
            workPhone: this.ruleForm.setPhoneDate,
            extraPhoneFirst: this.ruleForm.extraPhoneFirst,
            extraPhoneSecond: this.ruleForm.extraPhoneSecond
          }
          this.$api.staffUpdateWorkPhone(data).then(res => {
            console.log(res)
            if (res.code == 0) {
              this.$message.success("设置成功！")
              this.setPhoneDialogVisible = false
              this.getStaffList()
            } else {
              this.$message.error("设置失败！")
            }
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    // 设置工作手机号
    setPhone(row) {
      console.log(row)
      this.PhoneID = row.id
      this.ruleForm.setPhoneDate = row.workPhone
      this.ruleForm.extraPhoneFirst = row.extraPhoneFirst
      this.ruleForm.extraPhoneSecond = row.extraPhoneSecond
      this.setPhoneDialogVisible = true;
    },
    // 关闭弹框
    handleCloseToInfo() {
      this.toInfoDialogVisible = false
    },
    handleCloseSetPassword() {
      this.setPasswordDialogVisible = false
    },
    handleCloseSetPhone() {
      this.setPhoneDialogVisible = false
      this.setPhoneDate = ""
    },
    // 关闭弹框结束
    pzRole(row) {
      this.employeeId = row.id;
      this.axios
        .get("/sys/v1/user/employee/get/role?employeeId=" + this.employeeId, {
          headers: {
            isLoading: false,
          },
        })
        .then((res) => {
          // console.log(res);
          if (res.code == 0) {
            this.authority = res.data;
          }
        });
    },
    // 登录后台
    staffLogin(row) {
      const username = row.workPhone ? row.workPhone : row.phoneNumber
      this.axios
        .get('/sys/v2/user/employee/createToken?username=' + username, {
          headers: {
            isLoading: false
          }
        })
        .then((res) => {
          // console.log(res);
          if (res.code == 0) {
            window.open(`/#/staiff_login?token=` + res.data)
          }
        })
    },
    is_null(content) {
      if (content) {
        return false;
      } else {
        return true;
      }
    },
    // handleCurrentChange(val) {
    // 	this.staiffList(`${val}`, this.orgCode);
    // },
    // 分页
    handleCurrentChange(val) {
      this.pageNo = val;
      this.getStaffList(this.orgCode);
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getStaffList(this.orgCode);
    },
    // 部门选择列表
    department() {
      this.axios
        .post(
          "/sys/v1/org/tree/select",
          {
            request: {
              orgName: "",
              orgType: "",
            },
            version: "",
          },
          {
            headers: {
              isLoading: false,
            },
          }
        )
        .then((res) => {
          console.log(res);
          if (res.code == 0) {
            this.options = res.data;
            const userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
            this.queryForm.orgId = userInfo.orgCodes
          } else {
            this.$message.error(res.message);
          }
        });
    },
    // 部门选择列表
    /***是否正常下拉框的数据请求***/
    statusData() {
      this.axios
        .get("/sys/v1/common/by/group?groupId=employee_status", {
          headers: {
            isLoading: false,
          },
        })
        .then((res) => {
          // console.log("是否正常下拉框的数据请求")
          // console.log(res);
          if (res.code == 0) {
            this.statusList = res.data;
          } else {
            this.$message.error(res.message);
          }
        });
    },
    // 角色下拉列表数据
    getRoleList() {
      const data = {
        pageNo: 1,
        pageSize: 10000
      }
      this.$api.rolePageList(data).then(res => {
        console.log(res)
        if (res.code == 0) {
          this.roleDataList = res.data.list
        } else {
          this.$message.error(res.message);
        }
      })
    },
    /***是否正常下拉框的数据请求***/
    /***重置搜索***/
    reset() {
      this.queryForm = {}
      this.queryForm.orgId = ""
      this.pageSize = 10;
      this.pageNo = 1;
      this.getStaffList();
    },
    /***搜索模拟数据***/
    searchEvent(type) {
      console.log(this.queryForm)
      // this.pageSize = 10;
      // this.pageNo = 1;
      this.getStaffList(type)
    },
    /***搜索模拟数据***/

    toRefreshUser() {
      this.refreshUserDialogVisible = true
    },
    handleCloseRefreshUser() {
      this.refreshUserDialogVisible = false
    },
    refreshUserConfirm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const data = {
            mobile: this.formRU.phoneNumber,
            baseOrgCode: "dingOrgBase",
          }
          this.$api.syncOneUserByMobile(data).then(res => {
            console.log(res)
            if (res.code == 0) {
              this.$message.success("刷新成功！")
              this.refreshUserDialogVisible = false
              this.getStaffList()
            } else {
              this.$message.error("设置失败！")
            }
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    }
  },
};
</script>

<style scoped lang="scss">
.div1 {
  margin-left: -16px;
  background: url(../../../assets/breadcrumb2.png);
  width: 120px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  color: #2d7edf;
}

.div2 {
  margin-left: -16px;
  background: url(../../../assets/breadcrumb1.png);
  width: 120px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  color: #fff;
}

// .container{
// 	width: 100%;
// 	// overflow-x:scroll;
// 	// background: #F5F5F5;
// }

.el-menu-vertical-demo {
  width: 200px;
  overflow-y: scroll;
  height: 700px;
}

.el-menu-input {
  padding: 0 15px;
  background: #fff;

  /deep/ .el-input__inner {
    height: 30px;
    border: 1px solid #eee;
    margin: 10px 0;
  }
}

.el-menu-vertical-demo::-webkit-scrollbar {
  width: 0;
  height: 0;
}

.btnp {
  display: inline-block;
  vertical-align: middle;
  padding: 0 10px;
  color: #0083ef;
}

.btnp:hover {
  color: #4168e7;
  cursor: pointer;
}

.addPerson {
  margin-top: 20px;
  padding: 10px 15px;
}

.Box {
  display: flex;
  justify-content: flex-start;
  width: 100%;

  .table_tab {
    width: 100%;
    margin-bottom: 50px;
  }
}

.table {
  border-radius: 5px;
  width: 100%;
}

/deep/ .distpicker-address-wrapper select {
  padding: 0rem 0.75rem;
  height: 30px;
  line-height: 30px;
  font-size: 15px;
}

/deep/ .expanded {
  background: #f5f7fa;
  color: #000;
}

/deep/ .el-table__expanded-cell[class*="cell"] {
  padding: 0px 50px;
}

.header {
  display: flex;
  align-items: center;
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #333333;
  padding-bottom: 10px;
}

.inquiry {
  background: #fff;
  padding: 10px 20px 10px 20px;
  border-radius: 5px;

  .el-form {
    margin-top: 10px;
  }
}

.inquiryTab {
  background: #fff;
  padding: 10px 20px 20px 20px;
  border-radius: 5px;

  .el-form {
    margin-top: 10px;
  }

  margin-top: 20px;
}

/deep/ .el-table__expand-icon>.el-icon {
  color: transparent;
}

.selectDate {
  display: inline-block;
  margin-right: 20px;

  span {
    display: inline-block;
    font-size: 15px;
    margin-right: 15px;
    vertical-align: middle;
  }

  .picker {
    display: inline-block;
    vertical-align: middle;
  }

  /deep/ .el-input__inner {
    width: 250px;
    height: 28px;
    line-height: 28px;
  }

  /deep/ .el-date-editor .el-range__icon {
    line-height: 23px;
  }

  /deep/ .el-date-editor .el-range-separator {
    line-height: 23px;
  }

  /deep/ .el-date-editor .el-range__close-icon {
    line-height: 22px;
  }
}

.table {
  margin-top: 10px;
  border: 1px solid #e8eaec;
  border-radius: 0;

  /deep/ .el-input--suffix .el-input__inner {
    background: #409eff;
    color: #fff;
    width: 104px;
    box-shadow: none;
  }

  /deep/ .el-button {
    padding: 10px 13px;
  }
}

/deep/ .el-table thead {
  color: #2d7edf;
  text-align: center;

  .cell {
    text-align: center;
  }
}

.operation {
  display: inline-block;
  margin-left: 20px;

  img {
    width: 20px;
    height: 20px;
  }
}

/deep/ .el-table td,
.el-table th {
  text-align: center;
}

.page {
  text-align: right;
  width: 100%;
  background: #f5f5f5;
  padding-right: 30px;
  position: fixed;
  bottom: 0px;
  right: 0px;
  z-index: 5;

  span {
    font-size: 14px;
    color: #666;
    display: inline-block;
    margin-left: 10px;
  }

  .el-pagination {
    display: inline-block;
    vertical-align: middle;
  }
}

.demo-table-expand {
  font-size: 0;
}

.demo-table-expand label {
  width: 200px;
  color: #99a9bf;
}

.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
  text-align: left;
}

/deep/ .el-table__row:hover {
  color: rgb(45, 125, 223);
}

/deep/ .el-dialog__header {
  padding: 20px 20px 20px 20px;
  border-bottom: 1px solid #d9d9d9;
  font-family: PingFang SC;
  font-weight: bold;
  line-height: 25px;
  color: #333333;
}

/deep/ .el-dialog {
  border-radius: 10px;
}

/deep/ .el-dialog__headerbtn {
  top: 15px;
}

/deep/ .el-dialog__headerbtn .el-dialog__close {}

.headerbox {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 10px;
  border-bottom: 1px solid #ededed;
  padding-bottom: 10px;
}

.title_left {
  width: 4px;
  height: 16px;
  background: #4c81eb;
  opacity: 1;
  margin-right: 10px;
}

.tabTitle {
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 25px;
  color: #333333;
  opacity: 1;
  margin-top: 10px;
  margin-bottom: 20px;
}

.headerTitle {
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #333333;
  opacity: 1;
  margin-top: 20px;
  margin-bottom: 15px;
}

/deep/ .el-form-item__label {
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #333333;
}

/deep/ .vxe-cell--title {
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #333333;
}

.red {
  color: #ff0000;
}

.green {
  color: #67c23a;
}

.gray {
  color: #666666;
}

/deep/ .el-input.is-disabled .el-input__inner {
  background-color: #fff;
  font-family: PingFang SC;
  font-weight: 400;
  color: #333333;
}

/deep/ .el-dialog__footer {
  border-top: 1px solid #d9d9d9;
  margin-top: -20px;
  padding-top: 20px;
}

/deep/ .el-table thead {
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: bold;
  line-height: 22px;
  color: #333333;
  opacity: 1;
}

.greenStatus {
  /deep/ .el-input__inner {
    color: #67c23a !important;
  }
}

.redStatus {
  /deep/ .el-input__inner {
    color: #ff0000 !important;
  }
}

.grayStatus {
  /deep/ .el-input__inner {
    color: #666666 !important;
  }
}
</style>
